import { StartFreeButton } from "@/components/marketing/MarketingButton";
import { Accent, SectionKicker } from "@/components/marketing/MarketingSection";

export default function FreeOfferBand() {
  return (
    <section className="px-[6vw] py-[100px] text-white [background:radial-gradient(circle_at_82%_25%,rgba(88,72,255,0.6),transparent_32%),linear-gradient(120deg,#081039,#121d72)] max-[680px]:px-5 max-[680px]:py-[76px]">
      <div className="mx-auto w-[min(1180px,100%)]">
        <SectionKicker className="!text-teal-500">
          Create with Lutely
        </SectionKicker>
        <h2 className="m-0 max-w-[900px] font-figtree text-[clamp(40px,5vw,66px)] font-black uppercase leading-[1.02] tracking-[-0.045em]">
          Create artwork. Use it on Lutely. <Accent>For free.</Accent>
        </h2>
        <p className="mb-[30px] mt-[22px] max-w-[660px] font-open-sans text-[19px] leading-[1.55] text-white/[0.72]">
          Create artwork and use it on your Lutely tracks and releases at no
          cost.
        </p>
        <StartFreeButton>Create Artwork</StartFreeButton>
      </div>
    </section>
  );
}
